<template>
  <div>
    <!-- 商品支付列表 begin -->
    <el-dialog class="vip_banner" :lock-scroll="false" title="支付中心" :visible.sync="visible" @close="$emit('update:show', false)" top="10vh" width="1080px" height="56vh" :show="show" :uploadPaper="uploadPaper" :destroy-on-close=true>
      <div class="toptip" v-if="uploadPaper.tipMsg">
        <div class="hr"></div>
        <span>{{uploadPaper.tipMsg}}</span>
        <div class="hr"></div>
      </div>
      <div class="toptip" v-else>
        <hr class="top">
      </div>
      <div class="vip_box_list">
        <div v-for="(item, idx) in goodsList" class="vip_box" :ref="'vipbox'" @click="selectGoods($event, idx)">
          <p class="box_title" v-if="item.is_submit_paper">单篇检测</p>
          <p class="box_title" v-else>{{item.title}}</p>
          <div class="box_price">
            <p v-if="item.is_submit_paper">{{item.money}}</p>
            <p v-else>{{item.price}}</p>
            <span>元</span>
            <s v-if="item.original_price">{{item.original_price}}元</s>
          </div>
          <hr>
          <p class="box_desc" v-if="item.is_submit_paper">{{item.price}}</p>
          <p class="box_desc" v-else>每日可检测{{item.day_check_limit}}篇</p>
        </div>
      </div>
      <div class="mid_box">
        <p>应付金额：</p>
        <span>{{payMoney}}元</span>
      </div>
      <div class="vip_qrcode_list" v-if="!card_id && payIsRender">
        <div class="qrcode_box">
          <div class="qrcode_pic_box" ref="wxPayQrcode">
          </div>
          <div v-if="hasWxErr" class="error_box">
            <img @click="reloadPayQrcode" src="/static/img/icon_reload.png" alt="">
            <div class="tip1">{{ errTitle }}</div>
            <div class="tip2">{{ wxErrMsg }}</div>
          </div>
          <div class="descbox">
            <img src="/static/img/icon_weixin.png" alt="">
            <p>使用微信扫码支付</p>
          </div>
        </div>
        <div class="qrcode_box">
          <div class="qrcode_pic_box" ref="aliPayQrcode">
          </div>
          <div v-if="hasAliErr" class="error_box">
            <img @click="reloadPayQrcode" src="/static/img/icon_reload.png" alt="">
            <div class="tip1">{{ errTitle }}</div>
            <div class="tip2">{{ aliErrMsg }}</div>
          </div>
          <div class="descbox">
            <img src="/static/img/icon_alipay.png" alt="">
            <p>使用支付宝扫码支付</p>
          </div>
        </div>
      </div>

      <el-select v-model="opentionValue" @change="changePayType($event)" id="payTypeSelect" placeholder="使用免费查重券*1" v-if="payIsRender && card_id">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <div class="paySubmitBtn" @click="notifySubmit" v-if="card_id">提交检测</div>
    </el-dialog>
    <!-- 商品支付列表 end -->
    <!-- 支付成功 begin -->
    <el-dialog class="pay_succ" :lock-scroll="false" title="" :visible.sync="showResult" @close="$emit('update:show', false)" top="20vh" width="420px" height="40vh" :showResult="showResult">
      <div class="pay_succ_box">
        <img src="/static/img/icon_pay_succ.png" alt="" class="">
        <span>{{payResTitle}}</span>
        <p v-if="payResMsg">{{payResMsg}}</p>
        <el-button type="primary" @click="notifySubmit">立即检测</el-button>
      </div>
    </el-dialog>
    <!-- 支付成功 end -->
  </div>
</template>

<script>
import {
  _user_get_vip_goods_list,
  _user_get_pay_url,
  _user_get_pay_result,
  get_user_coupon,
  _get_gz_user_coupon
} from "../../../api";
import QRCode from "qrcodejs2";
export default {
  name: "vipPayBanner",
  data() {
    return {
      visible: this.show,
      goodsList: [],
      wxPayUrl: "",
      wxPayTid: "",
      aliPayUrl: "",
      aliPayTid: "",
      qrcodeTimer: "",
      checkTimer: "",
      payTid: "",
      payMoney: 0,
      payGoodsId: "",
      hasWxErr: true,
      hasAliErr: true,
      errTitle: "正在加载，请稍候...",
      wxErrMsg: "",
      aliErrMsg: "",
      payResMsg: "", // 支付结果提示 例如 有效期至2021年10月15日，每日可检测5篇论文
      payResTitle: "开通会员成功",
      card_id:'',
      options: [{
        value: '1',
        label: '使用免费查重券*1'
      }, {
        value: '0',
        label: '不使用论文查重券'
      }],
      opentionValue: '1',
      payIsRender:false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    showResult: {
      type: Boolean,
      default: false,
    },
    uploadPaper: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    /**
     * 通过点击事件主动选择商品
     */
    selectGoods(event, goodsIdx) {
      this.resetVipBoxStyle();
      event.currentTarget.className = "vip_box_selected";
      let goodsObj = this.goodsList[goodsIdx];
      if(goodsObj.is_submit_paper && this.opentionValue != -1){
        this.getUserCoupon(goodsObj);
        return;
      }else{
        this.opentionValue = '0';
        this.card_id = '';
      }

      this.payMoney = goodsObj.is_submit_paper
        ? goodsObj.money
        : goodsObj.price;
      this.getPayUrlQrcode(goodsObj.id).catch((err) => {
        this.$msg.error(err.info);
        this.renderErrorBox(true, err.info, true, err.info);
      });
    },
    getUserCoupon(goodsObj) {
      var that = this;
      get_user_coupon().then((res) => {
        that.card_id = res.card_id;
        that.options[0].value = res.card_id;
        that.opentionValue = res.card_id;
        that.payMoney = 0;
        that.payIsRender = true;
      }).catch((err) => {
        _get_gz_user_coupon().then((res) => {
          that.card_id = res[0].card_id;
          that.options[0].value = res[0].card_id;
          that.opentionValue = res[0].card_id;
          that.payMoney = 0;
          that.payIsRender = true;
        }).catch((err) => {
          that.payIsRender = true;
          that.payMoney = goodsObj.is_submit_paper ? goodsObj.money : goodsObj.price;
          that.getPayUrlQrcode(goodsObj.id).catch((err) => {
            that.$msg.error(err.info);
            that.renderErrorBox(true, err.info, true, err.info);
          });
        });
      });
    },
    changePayType(e) {
      if(e != 0) return;
      this.card_id = '';
      this.opentionValue = '-1';
      this.$refs.vipbox[0].click();
    },
    /**
     * 渲染商品列表，并默认选中第一件商品
     */
    renderGoodsList() {
      return this.getGoodsBuyList()
        .then((res) => {
          this.goodsList = res;
          if (this.payGoodsId) return;
          if (this.goodsList[0].is_submit_paper) {
            this.payGoodsId = this.goodsList[1].id;
          }else{
            this.payGoodsId = this.goodsList[0].id;
          }
        })
        .then((res) => {
          if(this.goodsList[0].is_submit_paper) {
            this.getUserCoupon(this.goodsList[1]);
          }else{
            this.payIsRender = true;
          }
        })
        .then((res) => {
          // 默认选择第一个商品，以下修改其样式和价格显示
          this.payIsRender = true;
          this.resetVipBoxStyle();

          if(this.goodsList[0].is_submit_paper) {
            this.$refs.vipbox[1].className = "vip_box_selected";
            this.payMoney = this.goodsList[1].money;
          }else{
            if(this.$refs.vipbox) this.$refs.vipbox[0].className = "vip_box_selected";
            this.payMoney = this.goodsList[0].price;
          }
        })
        .then((res) => {
          return this.getPayUrlQrcode(this.payGoodsId);
        });
    },
    /**
     * 创建二维码倒计时器
     */
    createQrcodeTimer(expireTime) {
      if (this.qrcodeTimer) window.clearInterval(this.qrcodeTimer);
      this.qrcodeTimer = setTimeout(() => {
        this.renderErrorBox(true, "二维码已过期", true, "二维码已过期");
      }, 1000 * expireTime);
    },
    /**
     * 封装二维码提示块
     */
    renderErrorBox(
      hasWxErr,
      wxErrMsg,
      hasAliErr,
      aliErrMsg,
      errTitle = "请点击刷新"
    ) {
      this.hasWxErr = hasWxErr;
      this.hasAliErr = hasAliErr;
      this.errTitle = errTitle;
      this.wxErrMsg = wxErrMsg;
      this.aliErrMsg = aliErrMsg;
    },
    /**
     * 二维码过期后重新请求
     */
    reloadPayQrcode() {
      this.getPayUrlQrcode(this.payGoodsId).catch((err) => {
        this.renderErrorBox(true, err.info, true, err.info);
      });
    },
    /**
     * 重置会员购买项为未选择的样式
     */
    resetVipBoxStyle() {
      let length = this.goodsList.length;
      if (length + 0 < 1) return;
      for (let i in this.$refs.vipbox) {
        this.$refs.vipbox[i].className = 'vip_box';
      }
    },
    /**
     * 获取所有商品项
     */
    getGoodsBuyList() {
      let params = {};
      if (JSON.stringify(this.uploadPaper) != "{}") {
        params.is_submit_paper = 1;
        params.type = this.uploadPaper.chktype;
        params.wordnum = this.uploadPaper.wordnum;
      }
      return _user_get_vip_goods_list(params);
    },
    /**
     * 封装支付URL
     */
    getPayUrlQrcode(goods_id) {
      let params = {};
      if (JSON.stringify(this.uploadPaper) != "{}") {
        params.type = this.uploadPaper.chktype;
        params.wordnum = this.uploadPaper.wordnum;
      }
      params.goods_id = goods_id;
      let that = this;
      return new Promise((resove, reject) => {
        _user_get_pay_url(params)
          .then((res) => {
            // 获取微信和支付订单信息
            that.wxPayUrl = res.wxpay.qrcode_url;
            that.wxPayTid = res.wxpay.tid;
            that.aliPayUrl = res.alipay.qrcode_url;
            that.aliPayTid = res.alipay.tid;
            that.payGoodsId = !goods_id ? goods_id : 0;
            // 生成微信支付宝支付二维码
            that.createWxPayUrlQrcode(that.wxPayUrl);
            that.createAliPayUrlQrcode(that.aliPayUrl);
            // 二维码在一定时间内有效，过期不可用
            that.hasWxErr = that.hasAliErr = false;
            that.createQrcodeTimer(res.wxpay.time_expire);
            // 定时获取支付结果
            that.checkPayResultTiemr();
            resove(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * 微信支付URL转为二维码
     */
    createWxPayUrlQrcode(payUrl) {
      this.$refs.wxPayQrcode.innerHTML = "";
      new QRCode(this.$refs.wxPayQrcode, {
        text: payUrl,
        width: 125,
        height: 125,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
      });
    },
    /**
     * 支付宝支付URL转为二维码
     */
    createAliPayUrlQrcode(payUrl) {
      this.$refs.aliPayQrcode.innerHTML = "";
      new QRCode(this.$refs.aliPayQrcode, {
        text: payUrl,
        width: 125,
        height: 125,
        colorDark: "#333333",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    /**
     * 检测支付结果
     */
    checkPayResultTiemr() {
      let params = {};
      if (this.wxPayTid) params.wxpay_tid = this.wxPayTid;
      if (this.aliPayTid) params.alipay_tid = this.aliPayTid;
      if (!this.wxPayTid && !this.aliPayTid) {
        this.$msg.error("购买商品不能为空！");
        return;
      }
      window.clearInterval(this.checkTimer);
      this.checkTimer = setInterval(() => {
        _user_get_pay_result(params)
          .then((res) => {
            if (res.pay_status !== "SUCCESS") return;
            // 清除定时器
            window.clearInterval(this.checkTimer);
            if (!this.payGoodsId) {
              // 选中单篇检测的商品，直接提交论文即可。
              this.notifySubmit();
              this.visible = false;
              return;
            }
            // 选中会员类型的商品，用户自行提交即可。
            this.showPayResult();
            this.payResMsg ="有效期至" +res.expire_time +"，每日可检测" +res.day_check_num +"篇论文";
          })
      }, 2000);
    },
    /**
     * 显示支付结果
     */
    showPayResult() {
      this.visible = false;
      setTimeout(() => {
        this.showResult = true;
      }, 250);
    },
    /**
     * 通知父组件提交论文
     */
    notifySubmit() {
      if (this.$route.path == "/userReport") {
        // 检测时购买会员成功，通知父组件提交论文
        if(this.card_id){
          this.$emit("onSubmit", this.card_id);
          return;
        }

        this.$emit("onSubmit");
        return;
      }
      // 首页购买会员成功，点击跳转检测页面
      this.$router.push("/userReport");
    },
  },
  watch: {
    show() {
      this.visible = this.show;
      if (!this.show) {
        window.clearInterval(this.checkTimer);
        return;
      }
      this.renderGoodsList()
        .then((res) => {
          this.checkPayResultTiemr();
        })
        .catch((err) => {
          this.renderErrorBox(true, err.info, true, err.info);
        });
    },
  },
  created() {
  },
};
</script>

<style scoped>
/* 商品列表 begin */

.top {
  margin-top: 20px;
  width: 100%;
}

.vip_box_list {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 188px;
  margin-top: 15px;
}

.vip_box {
  cursor: pointer;
  margin: 23px 0px;
  height: 138px;
  width: 180px;
  border: 2px solid #ebebeb;
  align-items: center;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.vip_box_selected {
  cursor: pointer;
  margin: 23px 0px;
  height: 138px;
  width: 180px;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  border: 2px solid #ff7900;
  background: url("/static/img/vip_selected.png") no-repeat;
  background-position: 135px 0px;
}

hr {
  opacity: 0.2;
  width: 90%;
}

.box_title {
  font-weight: bold;
  font-size: 14px;
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
}

.box_price {
  align-items: baseline;
  display: flex;
  justify-content: center;
  flex: 1;
}

.box_price p {
  color: #ff7900;
  font-size: 35px;
  font-weight: bold;
}

.box_price span {
  font-size: 12px;
}

.box_price s {
  font-size: 12px;
  opacity: 0.5;
  margin-left: 5px;
}

.box_desc {
  letter-spacing: 1px;
  font-size: 12px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  opacity: 0.5;
}

.mid_box {
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin: 5px 0px;
  height: 50px;
  align-items: center;
}

.mid_box p {
  justify-content: center;
  font-weight: bold;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  display: flex;
}

.mid_box span {
  font-family: PingFangSC-Semibold;
  font-weight: bold;
  color: #ff7900;
  font-size: 24px;
  margin-bottom: 10px;
}
.vip_qrcode_list {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.qrcode_box {
  margin: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.qrcode_pic_box {
  display: flex;
  margin: 10px;
  width: 152px;
  height: 152px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}

.qrcode_pic_box img {
  width: 125px;
  height: 125px;
}

.descbox {
  justify-content: space-between;
  display: flex;
  align-items: center;
}

.descbox img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
/* 商品列表 end */

/* 支付成功 begin */
.pay_succ_box {
  height: 304px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
}
.pay_succ_box img {
  width: 175px;
  height: 169px;
}
.pay_succ_box span {
  font-weight: bold;
  font-size: 18px;
}
.pay_succ_box p {
  font-size: 14px;
  color: #666666;
  opacity: 0.9;
}
/* 支付成功 end */

/* 二维码提示 begin */
.error_box {
  width: 150px;
  height: 150px;
  opacity: 0.7;
  bottom: 163px;
  border-radius: 5px;
  background: #ebebeb;
  position: relative;
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ebebeb;
}
.error_box img {
  width: 45px;
  height: 45px;
  cursor: pointer;
}
.tip1 {
  color: #000000;
}
.tip2 {
  color: red;
}
/* 二维码提示 end */

/* 购买会员提示 begin*/
.toptip {
  margin-top: -30px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
.toptip span {
  font-size: 16px;
  font-weight: bold;
}
.hr {
  width: 100%;
  border: 0.5px solid #ebebeb;
}
.pay_succ_box button {
  background: #3AAA2B;
  border: 1px solid #3AAA2B;
}
/* 购买会员提示 end*/
.paySubmitBtn{
  width: 138px;
  height: 44px;
  background: #3AAA2B;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 44px;
  margin:0 auto;
  margin: 50px auto 63px;
  cursor: pointer;
}
</style>

<style lang="">
/* dialog 定制 begin */
.el-dialog__headerbtn {
  top: 20px !important;
  background: url("/static/img/icon_close.png") left no-repeat !important;
  width: 20px;
  height: 20px;
  background-size: contain !important;
}
.el-dialog__headerbtn i {
  visibility: hidden;
}
.vip_banner > div:nth-child(1) {
  border-radius: 10px;
}
.pay_succ > div:nth-child(1) {
  border-radius: 10px;
}
#payTypeSelect{
  width: 189px;
  height: 38px;
  border: 1px solid #EBEBEB;
  border-radius: 4px;
  text-align: left;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #F33838;
  padding-left: 28px;
}
/* dialog 定制 end */
</style>


// WEBPACK FOOTER //
// src/components/User/VipPay/Banner.vue